export enum ERequestType {
    REQUEST_UNKOWN = 'REQUEST_UNKNOWN',
    REQUEST_MOCK = 'REQUEST_MOCK',
    REQUEST_GET = 'REQUEST_GET',
    REQUEST_POST = 'REQUEST_POST',
    REQUEST_PUT = 'REQUEST_PUT',
    REQUEST_PATCH = 'REQUEST_PATCH',
    REQUEST_DELTE = 'REQUEST_DELTE'
}
